import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("infak_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("infak_token", data.token);
    localStorage.setItem("infak_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("infak_token");
    localStorage.removeItem("infak_user");
    setUser(null);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("infak_user", JSON.stringify(data));
      setUser(data);
    } catch (e) {
      logout();
    }
  };

  useEffect(() => {
    if (localStorage.getItem("infak_token") && !user) {
      refresh();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, refresh, loading, setLoading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
